export interface AvailableSite {
  avatarUrl: string;
  cloudId: string;
  displayName: string;
  isVertigo: boolean;
  products: string[];
  url: string;
}

export type ProductName = 'jira' | 'confluence';

export interface Site {
  name: string;
  url: URL;
  products: ProductName[];
  cloudId: string;
  iconUrl: URL | null;
}

export interface CloudId {
  cloudId: Site['cloudId'];
}

export type AccessibleProductsRequest = {
  productIds: ProductId[];
  permissionIds: PermissionId[];
};

export interface AccessibleProductsResponse {
  products: Product[];
}

export interface Product {
  productId: ProductId;
  workspaces: Workspace[];
}

export interface Workspace {
  cloudId: string;
  cloudUrl: string;
  orgId: string;
  workspaceAvatarUrl: string | null;
  workspaceDisplayName: string;
  workspaceUrl: string; // This will have the custom domain
}

export enum ProductId {
  CONFLUENCE = 'confluence.ondemand',
  JIRA_SOFTWARE = 'jira-software.ondemand',
  JIRA_BUSINESS = 'jira-core.ondemand',
  JIRA_SERVICE_DESK = 'jira-servicedesk.ondemand',
  JIRA_PRODUCT_DISCOVERY = 'jira-product-discovery',
  COMPASS = 'compass',
  OPSGENIE = 'opsgenie',
  STATUSPAGE = 'statuspage',
  ATLAS = 'townsquare',
  JIRA_INCIDENT_MANAGER = 'jira-incident-manager.ondemand', // discontinued
  HIPCHAT = 'hipchat.cloud', // discontinued
}

export enum PermissionId {
  WRITE = 'write',
}

export const availableSiteToProductName: Record<ProductId, ProductName | undefined> = {
  [ProductId.JIRA_SOFTWARE]: 'jira',
  [ProductId.JIRA_BUSINESS]: 'jira',
  [ProductId.JIRA_SERVICE_DESK]: 'jira',
  [ProductId.JIRA_PRODUCT_DISCOVERY]: 'jira',
  [ProductId.CONFLUENCE]: 'confluence',
  // products not used in canvas do not currently map to a product name
  [ProductId.COMPASS]: undefined,
  [ProductId.OPSGENIE]: undefined,
  [ProductId.STATUSPAGE]: undefined,
  [ProductId.ATLAS]: undefined,
  // diuscointinued product types never map to a product name
  [ProductId.JIRA_INCIDENT_MANAGER]: undefined,
  [ProductId.HIPCHAT]: undefined,
};

export function getAvailableSitesUsedByCanvas(): ProductId[] {
  return Object.entries(availableSiteToProductName)
    .filter(([, value]) => !!value)
    .map(([key]) => key as ProductId);
}
